// src/constants/userDefaults.js
import { Session } from "../utils/sessionUtils";
import { getValuesByPropertyPath, getRandomInteger } from "../utils/dataUtils";

export const initialUserState = {
	id: null,
	email: "",
	full_name: "",
	status_id: "",
	organization: "",
	job_title: "",
	duty_location: "",
	createdAt: "",
	createdBy: "",
	updatedAt: "",
	updatedBy: "",
	user_roles: [],
};

export const initialRoleState = [];

export const initialUserGroupState = {
	id: 0,
	name: "",
	group_code: "",
	comments: "",
	sort_id: 100,
	status_id: 1,
	user_accesses: [],
	user_roles: [],
	users: [],
	createdAt: new Date(),
	createdBy: Session().currUser.id,
	updatedAt: "",
	updatedBy: Session().currUser.id,
};

export const initialBaselineState = (lookups) => {
	return {
		id: null,
		name: "",
		description: "",
		status_id: 1,
		currency_code: "USD",
		currency_display_decimal: 0,
		currency_id: 0,
		currency_symbol: "$",
		currency_unit: "B",
		number_of_period: 3,
		createdAt: new Date(),
		createdBy: Session().currUser.id,
		updatedAt: "",
		updatedBy: Session().currUser.id,
		BL_CFG_TYPES: lookups.BL_CFG_TYPES,
	};
};

export const initialBaselineItemState = (baseline, options) => {
	return {
		id: null,
		baseline_id: baseline.id,
		number_of_period: baseline.number_of_period,
		baseline_item_configs: [],
		name: "",
		description: "",
		military_service_id: "",
		domain_id: "",
		category_id: "",
		option_type_id: "",
		optionIds: getValuesByPropertyPath(options, "id"),
		options: options,
		sort_id: 0,
		status_id: 1,
		data_status_id: 1,
		createdAt: new Date(),
		createdBy: Session().currUser.id,
		updatedAt: "",
		updatedBy: Session().currUser.id,
	};
};

export const initialScenarioState = {
	id: null,
	baseline_id: null,
	name: "",
	description: "",
	status_id: 1,
	createdAt: new Date(),
	createdBy: Session().currUser.id,
	updatedAt: "",
	updatedBy: Session().currUser.id,
};

export const initialAuctionPackageState = {
	id: null,
	baseline_id: null,
	name: "",
	description: "",
	current_Price: null,
	startAt: null,
	endAt: null,
	status_id: 1,
	createdAt: new Date(),
	updatedAt: null,
	comments: "",
	internal_note: "",
	createdBy: Session().currUser.id,
	updatedBy: Session().currUser.id,
	baseline: { baseline_configs: [], baseline_items: [] },
};
